const setIsPageLoading = (context, isPageLoading) => {
  context.commit('IS_PAGE_LOADING_UPDATED', isPageLoading)
}

const setIsComponentLoading = (context, isComponentLoading) => {
  context.commit('IS_COMPONENT_LOADING_UPDATED', isComponentLoading)
}

const setError = (context, error) => {
  context.commit('APP_ERROR_UPDATED', error)
}

const setNotification = (context, notification) => {
  context.commit('APP_NOTIFICATION_UPDATED', notification)
}

export default {
  setIsPageLoading,
  setIsComponentLoading,
  setError,
  setNotification,
}
